var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":"Targets (Updates here are immediately executed)"}},[_vm._l((_vm.targetsKeys),function(targetId){return _c('edit-project-one-target',{key:targetId,attrs:{"target":_vm.targets[targetId],"targetId":targetId,"projectId":_vm.projectId}})}),_c('b-button',{on:{"click":_vm.addNewTarget}},[_vm._v("Add New Target")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }